import { Component, OnInit, Injector } from '@angular/core';
import { OverlayService } from '../services/overlay.service';
import { fadeInUp } from '../services/animations/fadeInUp.animation'
import { FormBuilder, FormGroup, Validators } from '@angular/forms'

import { ReviewQuestions } from '../services/review-questions.service';
import { ReviewService } from '../services/review.service'
import { _localeFactory } from '@angular/core/src/application_module';
import { CheckBadWord } from '../services/validators/bad-word.validator';

@Component({
    selector: 'app-leave-review',
    templateUrl: './leave-review.component.html',
    animations: [fadeInUp]
})
export class LeaveReviewComponent implements OnInit {
    content: any
    reviewForm: FormGroup
    reviewSubmitted: Boolean = false
    errors: Array<any>
    message: Array<any>
    questions: Array<any>
    formMonths: Array<any> = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12']
    formYears: Array<any>

    userType: String = 'Student'
    scoreArray: Array<any> = []

    constructor(
        private fbuilder: FormBuilder,
        private injector: Injector,
        private overlayService: OverlayService,
        private reviewQuestions: ReviewQuestions,
        private reviewService: ReviewService
    ) {
        this.content = this.injector.get('content');
        this.userType = this.content.currentUser.userType
        if (this.userType === 'Employer') {
            this.questions = reviewQuestions.employers
        } else {
            this.questions = reviewQuestions.students
        }

        this.reviewForm = this.fbuilder.group({
            'title': [null, Validators.compose([Validators.required, Validators.maxLength(80), CheckBadWord])],
            'comment': [null, Validators.compose([Validators.required, Validators.maxLength(500), CheckBadWord])],
            'score': [null],

            'completedCourse': [null],
            'workExperienceWasBeneficial': [null],
            'trainersWereKnowledgeable': [null],

            // Students Questions
            'completedHalfCourse': [null],
			'notCompletedBecause': [null],
            'notCompletedBecauseStillDoing': [null],
            'notCompletedBecauseStillDoingMonth': [null],
            'notCompletedBecauseStillDoingYear': [null],
            'notCompletedBecauseOther': [null, Validators.compose([CheckBadWord])],
            'completedCourseIn': [null],
            'completedCourseInMonth': [null],
            'completedCourseInYear': [null],
            'howWasCourseDelivered': [null],
            'easeOfAdministrationProcedures': [null],
            'involveAnyPracticalWorkExperience': [null],
            'whoArrangedWork': [null],
            'assessmentsBasedOnRealisticActivities': [null],
            'trainersWereResponsive': [null],
            'describesYourSituation': [null],
            'describesYourSituationStillLooking': [null, Validators.compose([CheckBadWord])],
            'howLikelyYouRecommend': [null],

            // Employers Questions
            'courseWasBeneficialToJobRole': [null],
            'trainingProviderDiscussedRequirements': [null],
            'trainingMetBusinessNeeds': [null],
            'trainingImprovedEmployeeKnowledge': [null],
            'metYourExpectations': [null],
            'howLikelyYouUseThisTrainingProvider': [null],

        })
        this.formValueChange()
    }

    ngOnInit() {
        const currentYear = new Date().getFullYear()
        let startYear = 2018
        this.formYears = []
        while (startYear <= currentYear + 2) {
            this.formYears.push(startYear++)
        }
    }

    formValueChange() {
        this.reviewForm.valueChanges.subscribe(val => {
            if (this.userType === 'Employer') {
                this.employerFormChanges(val)
            } else {
                this.studentFormChanges(val)
            }
        })
    }

    studentFormChanges(val) {
        if (this.reviewForm.value.title) {
            document.getElementById('completedCourse').classList.remove('inactive')
        }
		if (this.reviewForm.value.completedCourse && this.reviewForm.value.completedCourse === 'Yes') {
			if (this.reviewForm.value.completedHalfCourse) this.reviewForm.controls['completedHalfCourse'].setValue(null)
			document.getElementById('completedHalfCourse').classList.add('inactive', 'not-needed')
		} else if (this.reviewForm.value.completedCourse && this.reviewForm.value.completedCourse === 'No') {
			document.getElementById('completedHalfCourse').classList.remove('inactive', 'not-needed')
		}
		if (this.reviewForm.value.completedCourse === 'No' && !this.reviewForm.value.completedHalfCourse) {
			if (this.reviewForm.value.completedCourseIn) this.reviewForm.controls['completedCourseIn'].setValue(null)
			if (this.reviewForm.value.completedCourseInMonth) this.reviewForm.controls['completedCourseInMonth'].setValue(null)
			if (this.reviewForm.value.completedCourseInYear) this.reviewForm.controls['completedCourseInYear'].setValue(null)
			if (this.reviewForm.value.howWasCourseDelivered) this.reviewForm.controls['howWasCourseDelivered'].setValue(null)
			if (this.reviewForm.value.easeOfAdministrationProcedures) this.reviewForm.controls['easeOfAdministrationProcedures'].setValue(null)
			if (this.reviewForm.value.involveAnyPracticalWorkExperience) this.reviewForm.controls['involveAnyPracticalWorkExperience'].setValue(null)
			if (this.reviewForm.value.whoArrangedWork) this.reviewForm.controls['whoArrangedWork'].setValue(null)
			if (this.reviewForm.value.workExperienceWasBeneficial) this.reviewForm.controls['workExperienceWasBeneficial'].setValue(null)
			if (this.reviewForm.value.assessmentsBasedOnRealisticActivities) this.reviewForm.controls['assessmentsBasedOnRealisticActivities'].setValue(null)
			if (this.reviewForm.value.trainersWereKnowledgeable) this.reviewForm.controls['trainersWereKnowledgeable'].setValue(null)
			if (this.reviewForm.value.trainersWereResponsive) this.reviewForm.controls['trainersWereResponsive'].setValue(null)
			if (this.reviewForm.value.describesYourSituation) this.reviewForm.controls['describesYourSituation'].setValue(null)
			if (this.reviewForm.value.howLikelyYouRecommend) this.reviewForm.controls['howLikelyYouRecommend'].setValue(null)
			document.getElementById('completedCourseIn').classList.add('inactive', 'not-needed')
			document.getElementById('howWasCourseDelivered').classList.add('inactive', 'not-needed')
			document.getElementById('easeOfAdministrationProcedures').classList.add('inactive', 'not-needed')
			document.getElementById('involveAnyPracticalWorkExperience').classList.add('inactive', 'not-needed')
			document.getElementById('whoArrangedWork').classList.add('inactive', 'not-needed')
			document.getElementById('workExperienceWasBeneficial').classList.add('inactive', 'not-needed')
			document.getElementById('assessmentsBasedOnRealisticActivities').classList.add('inactive', 'not-needed')
			document.getElementById('trainersWereKnowledgeable').classList.add('inactive', 'not-needed')
			document.getElementById('trainersWereResponsive').classList.add('inactive', 'not-needed')
			document.getElementById('describesYourSituation').classList.add('inactive', 'not-needed')
			document.getElementById('howLikelyYouRecommend').classList.add('inactive', 'not-needed')
			document.getElementById('comment').classList.add('inactive', 'not-needed')
		}
		if ((this.reviewForm.value.completedCourse && this.reviewForm.value.completedCourse === 'Yes') || (this.reviewForm.value.completedCourse === 'No' && this.reviewForm.value.completedHalfCourse === 'Yes')) {
			if (this.reviewForm.value.notCompletedBecause) this.reviewForm.controls['notCompletedBecause'].setValue(null)
			if (this.reviewForm.value.notCompletedBecauseStillDoing) this.reviewForm.controls['notCompletedBecauseStillDoing'].setValue(null)
            if (this.reviewForm.value.notCompletedBecauseStillDoingMonth) this.reviewForm.controls['notCompletedBecauseStillDoingMonth'].setValue(null)
            if (this.reviewForm.value.notCompletedBecauseStillDoingYear) this.reviewForm.controls['notCompletedBecauseStillDoingYear'].setValue(null)
			if (this.reviewForm.value.notCompletedBecauseOther) this.reviewForm.controls['notCompletedBecauseOther'].setValue(null)
            document.getElementById('notCompletedBecause').classList.add('inactive', 'not-needed')
            document.getElementById('completedCourseIn').classList.remove('inactive', 'not-needed')
            document.getElementById('howWasCourseDelivered').classList.remove('not-needed')
            document.getElementById('easeOfAdministrationProcedures').classList.remove('not-needed')
            document.getElementById('involveAnyPracticalWorkExperience').classList.remove('not-needed')
            document.getElementById('whoArrangedWork').classList.remove('not-needed')
            document.getElementById('workExperienceWasBeneficial').classList.remove('not-needed')
            document.getElementById('assessmentsBasedOnRealisticActivities').classList.remove('not-needed')
            document.getElementById('trainersWereKnowledgeable').classList.remove('not-needed')
            document.getElementById('trainersWereResponsive').classList.remove('not-needed')
            document.getElementById('describesYourSituation').classList.remove('not-needed')
            document.getElementById('howLikelyYouRecommend').classList.remove('not-needed')
            document.getElementById('comment').classList.add('inactive', 'not-needed')
        } else if ( (this.reviewForm.value.completedCourse && this.reviewForm.value.completedCourse === 'No') && (this.reviewForm.value.completedHalfCourse && this.reviewForm.value.completedHalfCourse === 'No') ) {
            if (this.reviewForm.value.completedCourseInMonth) this.reviewForm.controls['completedCourseInMonth'].setValue(null)
            if (this.reviewForm.value.completedCourseInYear) this.reviewForm.controls['completedCourseInYear'].setValue(null)
            if (this.reviewForm.value.howWasCourseDelivered) this.reviewForm.controls['howWasCourseDelivered'].setValue(null)
            if (this.reviewForm.value.easeOfAdministrationProcedures) this.reviewForm.controls['easeOfAdministrationProcedures'].setValue(null)
            if (this.reviewForm.value.involveAnyPracticalWorkExperience) this.reviewForm.controls['involveAnyPracticalWorkExperience'].setValue(null)
            if (this.reviewForm.value.whoArrangedWork) this.reviewForm.controls['whoArrangedWork'].setValue(null)
            if (this.reviewForm.value.workExperienceWasBeneficial) this.reviewForm.controls['workExperienceWasBeneficial'].setValue(null)
            if (this.reviewForm.value.assessmentsBasedOnRealisticActivities) this.reviewForm.controls['assessmentsBasedOnRealisticActivities'].setValue(null)
            if (this.reviewForm.value.trainersWereKnowledgeable) this.reviewForm.controls['trainersWereKnowledgeable'].setValue(null)
            if (this.reviewForm.value.trainersWereResponsive) this.reviewForm.controls['trainersWereResponsive'].setValue(null)
            if (this.reviewForm.value.describesYourSituation) this.reviewForm.controls['describesYourSituation'].setValue(null)
            document.getElementById('notCompletedBecause').classList.remove('inactive', 'not-needed')
            document.getElementById('completedCourseIn').classList.add('inactive', 'not-needed')
            document.getElementById('howWasCourseDelivered').classList.add('inactive', 'not-needed')
            document.getElementById('easeOfAdministrationProcedures').classList.add('inactive', 'not-needed')
            document.getElementById('involveAnyPracticalWorkExperience').classList.add('inactive', 'not-needed')
            document.getElementById('whoArrangedWork').classList.add('inactive', 'not-needed')
            document.getElementById('workExperienceWasBeneficial').classList.add('inactive', 'not-needed')
            document.getElementById('assessmentsBasedOnRealisticActivities').classList.add('inactive', 'not-needed')
            document.getElementById('trainersWereKnowledgeable').classList.add('inactive', 'not-needed')
            document.getElementById('trainersWereResponsive').classList.add('inactive', 'not-needed')
            document.getElementById('describesYourSituation').classList.add('inactive', 'not-needed')
            document.getElementById('howLikelyYouRecommend').classList.add('inactive', 'not-needed')
            document.getElementById('comment').classList.add('inactive', 'not-needed')
        }
        if (this.reviewForm.value.notCompletedBecause) {
			document.getElementById('howLikelyYouRecommend').classList.remove('inactive', 'not-needed')
        }
        if (this.reviewForm.value.completedCourseInMonth && this.reviewForm.value.completedCourseInYear) {
            document.getElementById('howWasCourseDelivered').classList.remove('inactive', 'not-needed')
        }
        if (this.reviewForm.value.howWasCourseDelivered) {
            document.getElementById('easeOfAdministrationProcedures').classList.remove('inactive', 'not-needed')
        }
        if (this.reviewForm.value.easeOfAdministrationProcedures) {
            document.getElementById('involveAnyPracticalWorkExperience').classList.remove('inactive', 'not-needed')
        }
        if (this.reviewForm.value.involveAnyPracticalWorkExperience && this.reviewForm.value.involveAnyPracticalWorkExperience === 'Yes') {
            document.getElementById('whoArrangedWork').classList.remove('inactive', 'not-needed')
            document.getElementById('workExperienceWasBeneficial').classList.remove('inactive')
        } else if (this.reviewForm.value.involveAnyPracticalWorkExperience && this.reviewForm.value.involveAnyPracticalWorkExperience === 'No') {
            if (this.reviewForm.value.whoArrangedWork) this.reviewForm.controls['whoArrangedWork'].setValue(null)
            if (this.reviewForm.value.workExperienceWasBeneficial) this.reviewForm.controls['workExperienceWasBeneficial'].setValue(null)
            document.getElementById('whoArrangedWork').classList.add('inactive', 'not-needed')
            document.getElementById('workExperienceWasBeneficial').classList.add('inactive', 'not-needed')
            document.getElementById('assessmentsBasedOnRealisticActivities').classList.remove('inactive', 'not-needed')
        }
        if (this.reviewForm.value.whoArrangedWork) document.getElementById('workExperienceWasBeneficial').classList.remove('inactive', 'not-needed')
        if (this.reviewForm.value.workExperienceWasBeneficial) document.getElementById('assessmentsBasedOnRealisticActivities').classList.remove('inactive', 'not-needed')
        if (this.reviewForm.value.assessmentsBasedOnRealisticActivities) document.getElementById('trainersWereKnowledgeable').classList.remove('inactive', 'not-needed')
        if (this.reviewForm.value.trainersWereKnowledgeable) document.getElementById('trainersWereResponsive').classList.remove('inactive', 'not-needed')
        if (this.reviewForm.value.trainersWereResponsive) document.getElementById('describesYourSituation').classList.remove('inactive', 'not-needed')
        if (this.reviewForm.value.describesYourSituation) document.getElementById('howLikelyYouRecommend').classList.remove('inactive', 'not-needed')
        if (this.reviewForm.value.howLikelyYouRecommend) document.getElementById('comment').classList.remove('inactive', 'not-needed')
    }

    employerFormChanges(val) {
		if (this.reviewForm.value.title) document.getElementById('completedCourse').classList.remove('inactive')
        if (this.reviewForm.value.completedCourse && this.reviewForm.value.completedCourse === 'My employee(s) did not complete the course') {
			if (this.reviewForm.value.courseWasBeneficialToJobRole) this.reviewForm.controls['courseWasBeneficialToJobRole'].setValue(null)
			if (this.reviewForm.value.workExperienceWasBeneficial) this.reviewForm.controls['workExperienceWasBeneficial'].setValue(null)
			if (this.reviewForm.value.trainersWereKnowledgeable) this.reviewForm.controls['trainersWereKnowledgeable'].setValue(null)
			if (this.reviewForm.value.trainingImprovedEmployeeKnowledge) this.reviewForm.controls['trainingImprovedEmployeeKnowledge'].setValue(null)
			if (this.reviewForm.value.trainingProviderDiscussedRequirements) this.reviewForm.controls['trainingProviderDiscussedRequirements'].setValue(null)
			if (this.reviewForm.value.trainingMetBusinessNeeds) this.reviewForm.controls['trainingMetBusinessNeeds'].setValue(null)
			if (this.reviewForm.value.metYourExpectations) this.reviewForm.controls['metYourExpectations'].setValue(null)
			if (this.reviewForm.value.howLikelyYouUseThisTrainingProvider) this.reviewForm.controls['howLikelyYouUseThisTrainingProvider'].setValue(null)
			document.getElementById('courseWasBeneficialToJobRole').classList.add('inactive', 'not-needed')
			document.getElementById('workExperienceWasBeneficial').classList.add('inactive', 'not-needed')
			document.getElementById('trainersWereKnowledgeable').classList.add('inactive', 'not-needed')
			document.getElementById('trainingProviderDiscussedRequirements').classList.add('inactive', 'not-needed')
			document.getElementById('trainingMetBusinessNeeds').classList.add('inactive', 'not-needed')
			document.getElementById('trainingImprovedEmployeeKnowledge').classList.add('inactive', 'not-needed')
			document.getElementById('metYourExpectations').classList.add('inactive', 'not-needed')
			document.getElementById('howLikelyYouUseThisTrainingProvider').classList.add('inactive', 'not-needed')
			document.getElementById('comment').classList.remove('inactive', 'not-needed')
        }
		if (this.reviewForm.value.completedCourse && this.reviewForm.value.completedCourse !== 'My employee(s) did not complete the course') {
			document.getElementById('courseWasBeneficialToJobRole').classList.remove('inactive', 'not-needed')
		}
		if (this.reviewForm.value.courseWasBeneficialToJobRole) document.getElementById('workExperienceWasBeneficial').classList.remove('inactive', 'not-needed')
		if (this.reviewForm.value.workExperienceWasBeneficial) {
			if (this.reviewForm.value.completedCourse && this.reviewForm.value.completedCourse === 'Yes') {
				if (this.reviewForm.value.trainingProviderDiscussedRequirements) this.reviewForm.controls['trainingProviderDiscussedRequirements'].setValue(null)
				if (this.reviewForm.value.trainingMetBusinessNeeds) this.reviewForm.controls['trainingMetBusinessNeeds'].setValue(null)
				if (this.reviewForm.value.trainersWereKnowledgeable) this.reviewForm.controls['trainersWereKnowledgeable'].setValue(null)
				if (this.reviewForm.value.trainingImprovedEmployeeKnowledge) this.reviewForm.controls['trainingImprovedEmployeeKnowledge'].setValue(null)
				document.getElementById('trainingProviderDiscussedRequirements').classList.add('inactive', 'not-needed')
				document.getElementById('trainingMetBusinessNeeds').classList.add('inactive', 'not-needed')
				document.getElementById('trainersWereKnowledgeable').classList.add('inactive', 'not-needed')
				document.getElementById('trainingImprovedEmployeeKnowledge').classList.add('inactive', 'not-needed')
				document.getElementById('comment').classList.add('inactive', 'not-needed')
				document.getElementById('metYourExpectations').classList.remove('inactive', 'not-needed')
			} else {
				document.getElementById('trainingProviderDiscussedRequirements').classList.remove('inactive', 'not-needed')
			}
		}
		if (this.reviewForm.value.trainingProviderDiscussedRequirements && this.reviewForm.value.trainingProviderDiscussedRequirements === 'No') {
			if (this.reviewForm.value.trainingMetBusinessNeeds) this.reviewForm.controls['trainingMetBusinessNeeds'].setValue(null)
			if (this.reviewForm.value.trainersWereKnowledgeable) this.reviewForm.controls['trainersWereKnowledgeable'].setValue(null)
			if (this.reviewForm.value.trainingImprovedEmployeeKnowledge) this.reviewForm.controls['trainingImprovedEmployeeKnowledge'].setValue(null)
			document.getElementById('trainingMetBusinessNeeds').classList.add('inactive', 'not-needed')
			document.getElementById('trainersWereKnowledgeable').classList.add('inactive', 'not-needed')
			document.getElementById('trainingImprovedEmployeeKnowledge').classList.add('inactive', 'not-needed')
			document.getElementById('metYourExpectations').classList.remove('inactive', 'not-needed')
        } else if (this.reviewForm.value.trainingProviderDiscussedRequirements && this.reviewForm.value.trainingProviderDiscussedRequirements === 'Yes') {
			document.getElementById('trainingMetBusinessNeeds').classList.remove('inactive', 'not-needed')
		}
		if (this.reviewForm.value.trainingMetBusinessNeeds) document.getElementById('trainersWereKnowledgeable').classList.remove('inactive', 'not-needed')
		if (this.reviewForm.value.trainersWereKnowledgeable) document.getElementById('trainingImprovedEmployeeKnowledge').classList.remove('inactive', 'not-needed')
		if (this.reviewForm.value.trainingImprovedEmployeeKnowledge) document.getElementById('metYourExpectations').classList.remove('inactive', 'not-needed')
		if (this.reviewForm.value.metYourExpectations) document.getElementById('howLikelyYouUseThisTrainingProvider').classList.remove('inactive', 'not-needed')
		if (this.reviewForm.value.howLikelyYouUseThisTrainingProvider) document.getElementById('comment').classList.remove('inactive', 'not-needed')
    }

    calcRating() {
        let val = 0
        let inputs = document.getElementsByTagName('input')
        for (let i = 0; i < inputs.length; i++) {
            if (inputs[i].type == 'radio' && inputs[i].checked && inputs[i].getAttribute('data-points')) {
                let points = inputs[i].getAttribute('data-points')
                val = val + parseInt(points)
            }
        }

        if (val < 8) val = 8
        if (this.userType === 'Employer') {
            val = (val / 32) * 5
        } else {
            val = (val / 30) * 5
        }

        this.scoreArray = [];
        for (let i = 0; i < Math.floor(val); i++) {
            this.scoreArray.push(1)
        }
        if (val - Math.floor(val) >= .5) {
            this.scoreArray.push(.5)
        }
        const toAdd = (5 - this.scoreArray.length)
        for (let i = 0; i < toAdd; i++) {
            this.scoreArray.push(0)
        }
        let roudScore = this.scoreArray.reduce((total, num) => {
            return total + num
        }, 0)
        return roudScore
    }

    submitReviewForm(isValid: Boolean, submission) {
        submission.userType = this.userType
        submission.user = this.content.currentUser._id
        submission.provider = this.content.provider._id
        submission.course = this.content.course._id
        submission.industry = this.content.industry
        submission.score = this.calcRating()
        this.errors = []
        this.reviewService.submitReview(submission).then(result => {
            this.reviewSubmitted = true
        }).catch(error => {
            let err = error.json()
            this.errors = err
        })
    }

    closeOverlay(arg: any) {
        if (this.reviewSubmitted) {
            location.reload()
        } else {
            document.getElementById('Main').classList.remove('is-hidden')
            if (!arg || (arg && arg.target.className === 'o-overlay')) {
                this.overlayService.overlayData.next(null)
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/modals/leave-review.component.ts